import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_headers.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { HeadingAttributes, Props } from '../utils/types'

export namespace HeaderTypeNS {
  export const h1 = 'h1'
  export const h2 = 'h2'
  export const h3 = 'h3'
}

type HeaderType =
  | typeof HeaderTypeNS.h1
  | typeof HeaderTypeNS.h2
  | typeof HeaderTypeNS.h3

interface HeaderProps extends Props {
  type?: HeaderType
}

const cx = bind(styles)

const Header = React.forwardRef<
  HTMLDivElement,
  HeadingAttributes & HeaderProps
>(({ className, type, ...props }, ref) => (
  <div ref={ref} className={cx([`core-${type}`], className)} {...props} />
))

export const H1 = React.forwardRef<
  HTMLDivElement,
  HeadingAttributes & HeaderProps
>((props, ref) => <Header ref={ref} type={HeaderTypeNS.h1} {...props} />)

export const H2 = React.forwardRef<
  HTMLDivElement,
  HeadingAttributes & HeaderProps
>((props, ref) => <Header ref={ref} type={HeaderTypeNS.h2} {...props} />)

export const H3 = React.forwardRef<
  HTMLDivElement,
  HeadingAttributes & HeaderProps
>((props, ref) => <Header ref={ref} type={HeaderTypeNS.h3} {...props} />)

Header.displayName = 'Header'

H1.displayName = 'H1'

H2.displayName = 'H2'

H3.displayName = 'H3'

export default addSubcomponents(
  {
    H1,
    H2,
    H3,
  },
  Header
)
